<template>
  <footer class="footer has-cards">
    <div class="container">
      <hr />
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-4">
          <a><b>SAGACA Sp. z o.o.</b></a>
          <p style="margin-bottom: 0px">ul. Domagały 1, 30-741 Kraków</p>
          <p style="margin-bottom: 0px">NIP: 6812096105</p>
          <p>KRS: 0001000537</p>
        </div>
        <div class="col-md-8">
          <p style="margin-bottom: 0px"><icon name="ni ni-email-83" color="black"> </icon>services@sagaca.eu</p>
          <p style="margin-bottom: 0px"><icon name="fa fa-phone" color="black"> </icon>+48 502 744 443</p>
        </div>
        
      </div>
      
      <div class="row text-center justify-content-start">
        <div class="copyright">
          &copy; {{ year }}
          <a href="#" rel="noopener">Sagaca</a>
        </div>
        <div class="col-md-10">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item" style="top: 0px">
              <a href="#/privacy-policy" class="nav-link" rel="noopener"
                >Privacy Policy</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
